import { createUserProfileApi } from "api/services/user-profile";
import logError from "utils/logError";

/**
 * Deletes the logged-in user
 */
const deleteUser = async (domainCountryCode: string): Promise<boolean> => {
  const userProfileApi = createUserProfileApi(domainCountryCode);
  try {
    await userProfileApi.delete("/v1/users");
    return true;
  } catch (e) {
    logError(e.message, {
      functionName: "deleteUser",
      service: "userprofile",
      statusCode: e.statusCode,
    });
    return false;
  }
};

export default deleteUser;
